export default __webpack_public_path__ + "static/animal-debt-feature-037d0813a3321403be718f0e1dc8218b.webp";